import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import CameraView from "./pages/CameraView/CameraView";
import CreateUser from "./pages/CreateUser/CreateUser";
import Login from "./pages/Login/Login";
import {
  AppInit,
  NotificationBox,
  Loader,
  PrivateRoutes,
  SignalRProvider,
} from "@shared/ui";
import DroneInfoPage from "./pages/DroneInfoPage/DroneInfoPage";
import UserPage from "./pages/UserPage/UserPage";
import Customers from "./pages/Customers/Customers";
import CreateDrone from "./pages/CreateDrone/CreateDrone";
import SettingsPage from "./pages/Settings/SettingsPage";
import StarlinkSettingsPage from "./pages/StarlinkSettings/StarlinkSettingsPage";
import CameraViewOnly from "./pages/CameraView/CameraViewOnly";

import "./App.css";
import Dashboard from "./pages/Dashboard/Dashboard";
import { useAppSelector } from "@shared/ui";
import DronesOnline from "./pages/DronesOnline/DronesOnline";
import Profile from "./pages/Profile/Profile";
import VerifyEmail from "./pages/VerifyEmail/VerifyEmail";
import ResetPasswordForm from "./pages/Login/components/ResetPasswordForm";
import ControlGuide from "./pages/ControlGuide/ControlGuide";

function App() {
  const showError = useAppSelector((store) => store.notificationStatus.value);
  const showLoader = useAppSelector((store) => store.fetchState.value);

  return (
    <div className="App">
      <Router>
        <SignalRProvider hub="/infoHub">
          <AppInit>
            <Routes>
              <Route element={<PrivateRoutes />}>
                <Route path="/create-user/" element={<CreateUser />} />
                <Route path="/create-drone/" element={<CreateDrone />} />
                <Route path="/customers/" element={<Customers />} />
                <Route path="/dashboard/" element={<Dashboard />} />
                <Route
                  path="/dashboard/control/:droneId"
                  element={<CameraView isViewOnly={false} />}
                />
                <Route
                  path="/dashboard/view/:droneId"
                  element={<CameraViewOnly isViewOnly={true} />}
                />
                <Route path="/dashboard/:droneId" element={<DroneInfoPage />} />
                <Route path="/user/:userId" element={<UserPage />} />
                <Route path="/settings/:droneId" element={<SettingsPage />} />
                <Route
                  path="/starlink-settings/:droneId"
                  element={<StarlinkSettingsPage />}
                />
                <Route path="/drones-online/" element={<DronesOnline />} />
                <Route path="/profile/" element={<Profile />} />
                <Route path="/control-guide/" element={<ControlGuide />} />
              </Route>

              <Route path="/login" element={<Login />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/reset" element={<ResetPasswordForm />} />
              <Route path="/" element={<Navigate to="/login" replace />} />
            </Routes>
          </AppInit>
        </SignalRProvider>
      </Router>
      {Boolean(showLoader) && <Loader />}
      {showError && <NotificationBox />}
    </div>
  );
}

export default App;
